import { PATH, Storage, Envs } from '@common';
import { React, Redirect, Route, Switch } from '@common/3rd';
import DeskHome from './desk-home';
import DeskNotFound from './desk-not-found';
import DeskAccountCreate from './account/account-create';
import { DeskQueryModel } from '@jl-types';
import { Modeller } from '@model';

const Sign = React.lazy(() => import(/* webpackChunkName: "desk-sign" */ './sign'));
const Account = React.lazy(() => import(/* webpackChunkName: "desk-account" */ './account'));
const ForgetPassword = React.lazy(() => import(/* webpackChunkName: "forget-password" */ './forget-password'));
const QuoteFlow = React.lazy(() => import(/* webpackChunkName: "quote-flow" */ './quote-flow'));
const ClaimService = React.lazy(() => import(/* webpackChunkName: "claim-service" */ './claim/claim-service'));
const EndorsementQuery = React.lazy(() => import(/* webpackChunkName: "query-endo" */ './query/query-endo'));
const EndorsementApplyList = React.lazy(() => import(/* webpackChunkName: "query-endo" */ './endo/endo-apply-list'));
const PolicyQuery = React.lazy(() => import(/* webpackChunkName: "query-policy" */ './query/query-policy'));
const QuotationQuery = React.lazy(() => import(/* webpackChunkName: "query-quote" */ './query/query-quote'));
const EndorsementInfo = React.lazy(() => import(/* webpackChunkName: "endo-info" */ './endo/endo-info'));
const RiskWarning = React.lazy(() => import(/* webpackChunkName: "risk-warning" */ './risk-warning'));
class DeskRoute extends React.Component {
	state = {
		quoteListModel: Modeller.asProxied({
			results: [],
			criteria: {},
			pagination: {}
        } as DeskQueryModel),
        policyListModel: Modeller.asProxied({
			results: [],
			criteria: {},
			pagination: {}
        } as DeskQueryModel),
        endoListModel: Modeller.asProxied({
			results: [],
			criteria: {},
			pagination: {}
        } as DeskQueryModel),
        endoApplyListModel: Modeller.asProxied({
			results: [],
			criteria: {},
			pagination: {}
		} as DeskQueryModel)
	};
	constructor(props: any, context?: any) {
		super(props, context);
		//绑定设置第三方地址
		Storage.Share.holderThirdDeskHome();
		Storage.Share.holderThirdDeskLogin();
	}

	render() {
		return (
			<Switch>
				<Route path={PATH.DESK_SIGN} render={() => <Sign />} />
				<Route
					path="/*"
					render={() => {
						if (!Envs.isAuthorized()) {
							return (
								<Switch>
									<Route
										path={PATH.DESK_ACCOUNT_CREATE}
										component={DeskAccountCreate}
									/>
									<Route exact path={PATH.DESK_FORGET_PASSWORD} render={() => <ForgetPassword />} />
									<Route exact path={PATH.DESK_HOME} render={() => <DeskHome />} />
									<Route path={PATH.RISK_WARNING} render={() => <RiskWarning />} />
									<Redirect to={PATH.DESK_SIGN} />
								</Switch>
							);
						} else {
							return (
								<Switch>
									<Route path={PATH.DESK_ACCOUNT} render={() => <Account />} />
									<Route exact path={PATH.DESK_NOT_FOUND} render={() => <DeskNotFound />} />
									<Route exact path={PATH.DESK_HOME} render={() => <DeskHome />} />
									<Route path={PATH.RISK_WARNING} render={() => <RiskWarning />} />
									<Route path={PATH.DESK_ACCOUNT} render={() => <Account />} />
									<Route exact path={PATH.DESK_FORGET_PASSWORD} render={() => <ForgetPassword />} />
									<Route path={PATH.DESK_QUOTE_FLOW} render={() => <QuoteFlow />} />
									<Route exact path={PATH.CLAIM_SERVICE} render={() => <ClaimService />} />
									<Route exact path={PATH.QUERY_QUOTE} render={() => <QuotationQuery model={this.state.quoteListModel}/>} />
									<Route exact path={PATH.QUERY_POLICY} render={() => <PolicyQuery model={this.state.policyListModel} />} />
									<Route exact path={PATH.QUERY_ENDO_APPLY} render={() => <EndorsementApplyList model={this.state.endoApplyListModel} />} />
									<Route exact path={PATH.ENDO} render={() => <EndorsementQuery  model={this.state.endoListModel} />} />
									<Route exact path={PATH.ENDO_INFO} render={({ match }) => {
										return ( <EndorsementInfo productType={match.params.productType}  keyNo={match.params.keyNo} action={match.params.action}/>);} }/>
									<Redirect to={PATH.DESK_NOT_FOUND} />
								</Switch>
						);
					}
				}}
				/>
			</Switch>
		);
	}
}

export default DeskRoute;
